import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiAlertCircle, FiArrowLeft } from 'react-icons/fi';

export default function NotFound() {
  return (
    <div className="flex-grow flex items-center justify-center py-12">
      <div className="bg-white rounded-[2rem] shadow-2xl p-10 text-center max-w-md w-full relative overflow-hidden">
        <div className="absolute top-0 right-0 -mt-10 -mr-10 w-32 h-32 bg-slate-50 rounded-full pointer-events-none"></div>
        
        <div className="relative z-10">
          <div className="w-20 h-20 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-6">
            <SafeIcon icon={FiAlertCircle} className="text-4xl text-red-400" />
          </div>
          <h1 className="text-2xl font-bold text-slate-900 mb-3">Page Not Found</h1>
          <p className="text-slate-500 mb-8 leading-relaxed">
            The page you are looking for doesn't exist, has been moved, or you don't have access to view it.
          </p>
          <Link 
            to="/login" 
            className="inline-flex items-center gap-2 px-6 py-3.5 bg-navy-900 text-white font-medium rounded-xl hover:bg-navy-800 transition-colors shadow-lg shadow-navy-900/20"
          >
            <SafeIcon icon={FiArrowLeft} />
            Return to Login
          </Link>
        </div>
      </div>
    </div>
  );
}